import { Button, ButtonGroup, Grid, MenuItem, Paper } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import { getBuildingSettingOption } from "../../../../api/buildingSettingApi";
import { getQueueRoom, getQueueMedicationDisplay } from "../../../../api/queueApi";
import { useClassApp } from "../../../../styles/useClassApp";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SelectDropOtions from "../../../components/SelectDropOtions";
import { useStyleMedicineAndCashier } from "../helpers/useStyleMedicineAndCashier";
import { Add, Remove } from "@material-ui/icons";
import { getTextSetting } from "../../../../api/textSettingApi";
import MedicineDisplayDateTime from "./MedicineDisplayDateTime";
import { useStyleDisplay } from "../helpers/useStyleDisplay";
import Slider from "react-slick";
import { convertArray } from "../helpers/helpers";

const synth = window.speechSynthesis;

const initialMedicineQueue = {
    queueWait: [],
    queueInRoom: [],
    queueHold: [],
    queueWaitPage: 1,
    queueWaitPerPage: 4,
    queueHoldPage: 1,
    queueHoldPerPage: 4,
    totalQueueWait: 0,
    totalQueueHold: 0,
};

/** @type {import("react-slick").Settings} */
const slickSettings = {
    dots: true,
    infinite: true,
    speed: 1000,
    arrows: false,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    className: "w-100 h-100 d-flex flex-column justify-content-between",
};

export default function MedicineDisplay() {
    const classes = useClassApp();
    const [valueZoom, setValueZoom] = useState(1);
    const classsDisplay = useStyleDisplay();
    const classDisplayMedicine = useStyleMedicineAndCashier(valueZoom);

    // ref
    const controllerRef = useRef(null);
    const refContainerGrid = useRef(null);
    const refElementsTitles = useRef(null);

    // componnent state
    const [medicineRoom, setMedicineRoom] = useState([]);
    const [buildingId, setBuildingId] = useState("");
    const [floorId, setFloorId] = useState("");
    const [floorObj, setFloorObj] = useState({});
    const [option, setOption] = useState({ building: [], floor: [] });
    const [showContent, setShowContent] = useState(false);
    const [tab, setTab] = useState({ id: 0, name: "" });
    const [medicineQueue, setMedicineQueue] = useState(initialMedicineQueue);
    const [movingText, setMovingText] = useState("");

    // text to speach
    const [speakTextQueue, setSpeakTextQueue] = useState([]);
    const voiceTH = synth.getVoices()?.find(item => item?.lang === "th-TH");
    const voiceEN = synth.getVoices()?.find(item => item?.lang === "en-US");

    // fetch doctor queue display
    const fetchMedicineQueueDisplay = async locationCode => {
        try {
            const queryParams = {
                locationCode,
            };
            const res = await getQueueMedicationDisplay(queryParams, controllerRef.current?.signal);
            if (res) {
                setMedicineQueue(currentState => ({
                    ...currentState,
                    queueWait: res?.patientWait || [],
                    queueHold: res?.patientHold || [],
                    queueInRoom: res?.patientInRoom || [],
                    totalQueueWait: res?.totalQueueWait || 0,
                    totalQueueHold: res?.totalQueueHold || 0,
                }));
                return res;
            }
            return {};
        } catch (error) {
            console.dir(error);
        }
    };

    // add fontsize
    const incrementFontSize = type => {
        if (type === "up") {
            return setValueZoom(prev => prev + 0.25);
        }
        if (valueZoom <= 1) {
            if (valueZoom !== 0) {
                return setValueZoom(prev => prev - 0.25);
            }
            return setValueZoom(0);
        }
        return setValueZoom(prev => prev - 0.25);
    };

    // fetch building setting option
    const fetchBuildingSettingOption = async signal => {
        try {
            const buildingSettingOption = await getBuildingSettingOption(signal);
            if (buildingSettingOption) {
                setOption(currentState => ({
                    ...currentState,
                    building: buildingSettingOption?.buildingOption,
                    floor: buildingSettingOption?.floorOption,
                }));
            }
        } catch (error) {
            console.dir(error);
        }
    };

    // fetch medicine room
    const fetchRoom = async (building = null, floor = null) => {
        try {
            const queryParams = {
                builingId: building || 0,
                floorId: floor || 0,
                statusRoom: "1",
            };
            const res = await getQueueRoom(queryParams, controllerRef.current?.signal);
            if (res) {
                setMedicineRoom(res?.data);
            }
        } catch (error) {
            console.dir(error);
        }
    };

    // function change select option
    const handleChangeSelectOption = async (type, val) => {
        if (type === 1) {
            setBuildingId(val);
            setFloorId("");
            setMedicineRoom([]);
        } else if (type === 2) {
            setFloorId(val);
            const floor = option?.floor?.find(item => item?.floorId === val);
            setFloorObj(floor);
            await fetchRoom(buildingId, val);
            await fetchMedicineQueueDisplay(floor?.locationCode);
        }
    };

    // change tab
    const handleChangeTab = async (idx, name) => {
        setTab({ id: idx, name });
    };

    // fetch text setting
    const fetchTextSetting = async signal => {
        try {
            const textSetting = await getTextSetting(signal);
            if (textSetting) {
                setMovingText(textSetting?.medicineText);
            }
        } catch (error) {
            console.dir(error);
        }
    };

    const fetchQueueWithVoice = async lastestQueue => {
        const medicineQueueRes = await fetchMedicineQueueDisplay(floorObj?.locationCode);
        const findLastestQueue = medicineQueueRes?.patientInRoom?.find(patient => patient?.QueueNo === lastestQueue);
        if (findLastestQueue?.QueueNo && findLastestQueue?.MedRoom?.name) {
            const queueNumber = findLastestQueue?.QueueNo?.split("")?.join(" ") || "";
            const roomNameTH = findLastestQueue?.MedRoom?.name || "";
            const roomNameEN = findLastestQueue?.MedRoom?.nameEn || "";
            setSpeakTextQueue(currentState => [
                ...currentState,
                {
                    text:
                        findLastestQueue?.Lang === "en"
                            ? `Queue number ${queueNumber}, please contact ${roomNameEN}.`
                            : `ขอเชิญหมายเลข  ${queueNumber}   ที่${roomNameTH}ครับ`,
                    lang: findLastestQueue?.Lang || "th",
                },
            ]);
        }
    };

    const fetchQueueWithoutVoice = async () => {
        await fetchMedicineQueueDisplay(floorObj?.locationCode);
    };

    // run only first render
    useEffect(() => {
        controllerRef.current = new AbortController();
        const init = async () => {
            await fetchBuildingSettingOption(controllerRef.current?.signal);
            await fetchTextSetting(controllerRef.current?.signal);
        };
        init();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, []);

    // toggle show content
    useEffect(() => {
        if (buildingId !== "" && floorId !== "") {
            setShowContent(true);
        } else {
            setShowContent(false);
        }
    }, [buildingId, floorId]);

    // connect socket.io
    useEffect(() => {
        let socket;
        if (floorId) {
            socket = io(`${process.env?.REACT_APP_HOST_SOCKET}/medicine-queue`, {
                transports: ["websocket"],
            });

            socket.on("connect", () => {
                socket.emit("join-medicine-room", floorId);
            });

            socket.on("medicine-queue-from-update", data => {
                if (data?.type === "without-voice") {
                    fetchQueueWithoutVoice();
                    return;
                }
                fetchQueueWithVoice(data?.QueueNo);
            });

            socket.on("medicine-queue-from-hch", () => {
                fetchQueueWithoutVoice();
            });
        }

        return () => {
            if (floorId && socket) {
                socket.off("connect");
                socket.off("join-medicine-room");
                socket.off("medicine-queue-from-update");
                socket.off("medicine-queue-from-hch");
                socket.off("disconnect");
                socket.emit("leave-medicine-room");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [floorId]);

    // auto speak
    useEffect(() => {
        if (speakTextQueue.length) {
            const utterance = new SpeechSynthesisUtterance(speakTextQueue[0]?.text);
            utterance.voice = speakTextQueue[0]?.lang === "en" ? voiceEN : voiceTH;
            utterance.rate = 0.5;
            utterance.pitch = 0.6;
            synth.speak(utterance);
        }
        setSpeakTextQueue(currentState => {
            currentState.shift();
            return currentState;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [speakTextQueue]);

    return (
        <Paper elevation={0} className={`px-3 ${classDisplayMedicine().container}`} style={{ height: "100vh" }}>
            <div className="d-flex flex-column justify-content-between h-100 w-100">
                {/* Head title */}
                <div>
                    <Grid
                        container
                        className="align-items-center py-5 shadow-sm rounded"
                        style={{
                            background: "linear-gradient(90deg, rgba(182, 227, 249, 0.55) 0%, #FFFFFF 100%)",
                        }}>
                        <Grid item xs={12} lg={6} className="px-3 mb-3 mb-xl-0">
                            <MedicineDisplayDateTime />
                        </Grid>
                        <Grid item xs={12} lg={6} className="px-3">
                            <Grid container spacing={1}>
                                <Grid item xs={12} lg={2}>
                                    <div className="d-flex flex-column">
                                        <ButtonGroup
                                            disableElevation
                                            className={`flex-fill ${classsDisplay.btnUpsizeFont}`}>
                                            <Button onClick={() => incrementFontSize("down")}>
                                                <Remove />
                                            </Button>
                                            <Button variant="text" className="flex-fill text-show-value text-center">
                                                x{valueZoom}
                                            </Button>
                                            <Button onClick={() => incrementFontSize("up")}>
                                                <Add />
                                            </Button>
                                        </ButtonGroup>
                                    </div>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <SelectDropOtions
                                        options={option?.building}
                                        useTheme={true}
                                        onChange={value => handleChangeSelectOption(1, value)}
                                        value={buildingId}
                                        placeholder="Select..."
                                        containerClass={classsDisplay?.inputDropdownText}
                                        papperClass={classsDisplay.dropdownMenuText}
                                        renderOption={row => {
                                            return (
                                                <MenuItem key={row?.buildingId + "_build"} value={row?.buildingId}>
                                                    {row?.name}
                                                </MenuItem>
                                            );
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <SelectDropOtions
                                        options={option?.floor?.filter(item => item?.buildingId === buildingId)}
                                        useTheme={true}
                                        onChange={value => handleChangeSelectOption(2, value)}
                                        value={floorId}
                                        placeholder="Select..."
                                        containerClass={classsDisplay?.inputDropdownText}
                                        papperClass={classsDisplay.dropdownMenuText}
                                        renderOption={row => {
                                            return (
                                                <MenuItem key={row?.floorId + "_floor"} value={row?.floorId}>
                                                    {row?.name} {row?.locationName}
                                                </MenuItem>
                                            );
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
                {/* content */}
                <div className="px-5 flex-fill d-flex w-100">
                    {showContent && (
                        <div className="flex-fill d-flex flex-column w-100">
                            <div
                                className="d-flex align-items-center"
                                style={{ overflowX: "auto", overflowY: "hidden" }}>
                                {["0", "2"].map((row, idx) => (
                                    <div key={"room_" + idx} className="col-4 col-sm-3 col-lg-2 px-0">
                                        <div
                                            className={`tab-btn ${classes.boxlistRoom} ${
                                                tab.id === idx ? "active" : ""
                                            }`}
                                            onClick={() => handleChangeTab(idx, `screen_${idx}`)}>
                                            <p className={`text-typo`}>{`หน้าจอ ${idx + 1}`}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="flex-fill d-flex flex-column w-100">
                                <div className="flex-grow-0 pb-5">
                                    <div className="d-flex">
                                        <div>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <img
                                                    src={toAbsoluteUrl("/media/HCH/logos/logo-big.png")}
                                                    className="img-fluid img-logo"
                                                    alt="logo"
                                                />
                                            </div>
                                        </div>
                                        <div className="flex-fill box-field-call d-flex align-items-center">
                                            <Grid container spacing={2} className="h-100">
                                                {medicineRoom?.map(room => (
                                                    <Grid key={room?.roomId} item xs={12} lg={4}>
                                                        <div
                                                            className={`d-flex align-items-stretch p-2 py-5 h-100 rounded shadow-sm ${classsDisplay.bgBlue} ${classsDisplay.shadow}`}>
                                                            <div
                                                                className="flex-fill d-flex justify-content-center align-items-center"
                                                                style={{ borderRight: "1px solid #fff" }}>
                                                                <p className="mb-0 text-center text-white text-call">
                                                                    {room?.name}
                                                                </p>
                                                            </div>
                                                            <div
                                                                className="flex-fill d-flex align-items-center"
                                                                style={{ borderLeft: "1px solid #fff" }}>
                                                                <p className="mb-0 text-center w-100 text-white text-call-number">
                                                                    {
                                                                        medicineQueue?.queueInRoom?.find(
                                                                            item => item?.MedicineRoom === room?.roomId,
                                                                        )?.QueueNo
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-fill w-100" ref={refContainerGrid} style={{ minHeight: 1 }}>
                                    {tab?.id === 0 && refContainerGrid.current?.offsetHeight && (
                                        <div className="w-100 h-100 flex-column d-flex">
                                            <div
                                                ref={refElementsTitles}
                                                className={`py-5 border rounded mb-3 ${classsDisplay.bgGray} ${classsDisplay.shadow}`}>
                                                <p className="text-center text-xxl">คิวรอรับยา</p>
                                            </div>
                                            <div className="w-100 flex-grow-1">
                                                <Slider
                                                    {...slickSettings}
                                                    infinite={convertArray(medicineQueue?.queueWait, 20)?.length > 1}>
                                                    {convertArray(medicineQueue?.queueWait, 20).map((item, index) => {
                                                        return (
                                                            <div key={`row-${index}`}>
                                                                <div className="grid-container">
                                                                    {item?.map((row, idx) => {
                                                                        return (
                                                                            <div
                                                                                className="grid-cols"
                                                                                key={"queue_wait_" + idx}>
                                                                                <div
                                                                                    className={`border d-flex align-items-center rounded w-100 ${
                                                                                        (idx >= 0 && idx <= 4) ||
                                                                                        (idx >= 10 && idx <= 14)
                                                                                            ? classsDisplay.bgGray
                                                                                            : classsDisplay.bgGray2
                                                                                    }`}>
                                                                                    <p className="text-center text-xxl w-100">
                                                                                        {row?.QueueNo}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </Slider>
                                            </div>
                                        </div>
                                    )}
                                    {tab?.id === 1 && (
                                        <div className="h-100 content-pane">
                                            <Grid container spacing={2} className="h-100">
                                                <Grid item xs={12} className="d-flex flex-column">
                                                    <div
                                                        ref={refElementsTitles}
                                                        className={`py-5 bg rounded mb-3 ${classsDisplay.bgGray} ${classsDisplay.shadow}`}>
                                                        <p className="text-center text-xxl">
                                                            คิวรับยาที่เรียกผ่านไปแล้ว
                                                        </p>
                                                    </div>
                                                    <Slider
                                                        {...slickSettings}
                                                        infinite={
                                                            convertArray(medicineQueue?.queueHold, 40)?.length > 1
                                                        }>
                                                        {convertArray(medicineQueue?.queueHold, 40).map(
                                                            (item, index) => {
                                                                return (
                                                                    <div key={`hold-${index}`}>
                                                                        <div className="grid-container cols-40">
                                                                            {item?.map((row, idx) => {
                                                                                return (
                                                                                    <div
                                                                                        className="grid-cols"
                                                                                        key={"queue_wait_" + idx}>
                                                                                        <div
                                                                                            className={`flex-fill d-flex align-items-center rounded h-100 ${
                                                                                                (idx >= 0 &&
                                                                                                    idx <= 7) ||
                                                                                                (idx >= 16 &&
                                                                                                    idx <= 23) ||
                                                                                                (idx >= 32 && idx <= 39)
                                                                                                    ? classsDisplay.bgGray
                                                                                                    : classsDisplay.bgGray2
                                                                                            }`}>
                                                                                            <p className="text-center text-xxl w-100">
                                                                                                {row?.QueueNo}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            },
                                                        )}
                                                    </Slider>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* footer */}
                <div className="mt-4 mt-md-3">
                    <Grid
                        container
                        className="align-items-center py-5 shadow-sm rounded"
                        // style={{ background: "linear-gradient(to right, #00b0e1, #9dddff)" }}
                        style={{ background: "rgb(77,167,218)" }}>
                        <Grid item xs={12} className="px-3">
                            <div className="d-flex align-items-center justify-content-center">
                                <div>
                                    <h3
                                        className={`text-white mb-0 text-center text-xl-left ${classsDisplay?.footerTextMarquee}`}>
                                        {movingText}
                                    </h3>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </Paper>
    );
}
